import { render, staticRenderFns } from "./compTable.vue?vue&type=template&id=2c589ace"
import script from "./compTable.vue?vue&type=script&lang=js"
export * from "./compTable.vue?vue&type=script&lang=js"
import style0 from "./compTable.vue?vue&type=style&index=0&id=2c589ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports